import { render, staticRenderFns } from "./RightsConfigs.vue?vue&type=template&id=28ebe274&"
import script from "./RightsConfigs.vue?vue&type=script&lang=js&"
export * from "./RightsConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28ebe274')) {
      api.createRecord('28ebe274', component.options)
    } else {
      api.reload('28ebe274', component.options)
    }
    module.hot.accept("./RightsConfigs.vue?vue&type=template&id=28ebe274&", function () {
      api.rerender('28ebe274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/rights/RightsConfigs.vue"
export default component.exports